
import { Component, Vue, toNative, Prop } from 'vue-facing-decorator';
import { toast, type ToastOptions } from 'vue3-toastify';
import 'vue3-toastify/dist/index.css';

@Component({})
class Toaster extends Vue {
  @Prop() message!: string;
  @Prop() defaultTimeout!: number;
  @Prop({default: 'success'}) type!: string;

  private mounted() {
    toast(this.message, {
      autoClose: this.defaultTimeout,
      position: toast.POSITION.TOP_CENTER,
      theme: 'colored',
      type: this.type,
      hideProgressBar: true,
      closeButton: false,
    } as ToastOptions);
  }
}

export default toNative(Toaster);
